import React from 'react';
import PropTypes from 'prop-types';
import { Helmet, HelmetProvider } from 'react-helmet-async';

// import Analytics from '../components/Template/Analytics';
import Navigation from '../components/Template/Navigation';
import SideBar from '../components/SideBar';
import ScrollToTop from '../components/Template/ScrollToTop';
import ModalRoot from '../modals/ModalRoot';

const Main = ({
  children = null,
  fullPage = false,
  title = null,
  description = "Tim Neville's personal website.",
}) => (
  <HelmetProvider>
    <ModalRoot />
    {/* <Analytics /> */}

    <ScrollToTop />

    <Helmet
      titleTemplate="%s | Tim Neville"
      defaultTitle="Tim Neville"
      defer={false}
    >
      {title && <title>{title}</title>}
      <meta name="description" content={description} />
    </Helmet>

    <div id="wrapper">
      <Navigation />

      <div id="main">{children}</div>
      {fullPage ? null : <SideBar />}
    </div>
  </HelmetProvider>
);

Main.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  fullPage: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default Main;
